import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { BRAND } from "@/site.config";

const WA_NUMBER = "596696687766"; // Martinique +596 + 0696687766 (drop leading 0)
const DEFAULT_MSG =
  "Bonjour SIGNA CLEAN, je souhaite obtenir un devis gratuit pour :";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const buildHref = () => {
    const text = encodeURIComponent(
      message.trim() ? `${DEFAULT_MSG} ${message.trim()}` : DEFAULT_MSG
    );
    return `https://wa.me/${WA_NUMBER}?text=${text}`;
  };

  const quickServices = [
    "Nettoyage de gouttières",
    "Nettoyage de façades / toitures",
    "Nettoyage / Lessivage de sols",
    "Dépoussiérage en hauteur",
    "Équipements photoluminescents",
    "Plots solaires LED",
  ];

  return (
    <div
      data-testid="whatsapp-floating"
      className={`fixed z-50 right-5 bottom-20 sm:right-6 sm:bottom-24 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {open && (
        <div
          data-testid="whatsapp-card"
          className="mb-3 w-[320px] sm:w-[360px] rounded-2xl overflow-hidden border border-[#9DEB30]/20 bg-[#0d0d0d] shadow-[0_20px_60px_rgba(0,0,0,0.6)] fade-up"
        >
          <div className="flex items-center justify-between px-4 py-3 bg-[#101010] border-b border-white/5">
            <div className="flex items-center gap-2.5">
              <div className="h-9 w-9 rounded-full bg-[#25D366] flex items-center justify-center">
                <MessageCircle size={16} className="text-white" />
              </div>
              <div>
                <div className="text-sm font-semibold text-white leading-tight">SIGNA CLEAN</div>
                <div className="text-[10px] font-mono uppercase tracking-wider text-[#9DEB30]">
                  · En ligne
                </div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-close"
              className="p-1 text-zinc-400 hover:text-white"
              aria-label="Fermer"
            >
              <X size={16} />
            </button>
          </div>

          <div className="p-4">
            <p className="text-sm text-zinc-300">
              Bonjour 👋 Quel service vous intéresse ?
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              {quickServices.map((s) => (
                <button
                  key={s}
                  onClick={() => setMessage(s)}
                  data-testid={`whatsapp-quick-${s.slice(0, 10)}`}
                  className={`text-[11px] px-3 py-1.5 rounded-full border transition ${
                    message === s
                      ? "border-[#9DEB30]/60 bg-[#9DEB30]/10 text-[#9DEB30]"
                      : "border-white/10 text-zinc-400 hover:border-[#9DEB30]/40 hover:text-white"
                  }`}
                >
                  {s}
                </button>
              ))}
            </div>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Votre message (optionnel)..."
              rows={3}
              data-testid="whatsapp-message"
              className="mt-3 w-full text-sm resize-none px-3 py-2.5 rounded-lg bg-black/40 border border-white/10 text-white placeholder:text-zinc-600 focus:outline-none focus:border-[#9DEB30]/50"
            />

            <a
              href={buildHref()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-send"
              className="mt-3 inline-flex w-full items-center justify-center gap-2 px-4 py-3 rounded-full bg-[#25D366] hover:bg-[#1FBE5A] text-white text-sm font-semibold transition"
            >
              <MessageCircle size={16} />
              Démarrer la conversation
            </a>
            <p className="mt-2 text-[10px] text-zinc-500 text-center">
              Réponse rapide · {BRAND.phone}
            </p>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle"
        aria-label="Discuter sur WhatsApp"
        className="group relative h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1FBE5A] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-all hover:scale-105"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" aria-hidden />
        {open ? <X size={22} className="relative" /> : <MessageCircle size={22} className="relative" />}
        {!open && (
          <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-[#9DEB30] ring-2 ring-[#0A0A0A]" />
        )}
      </button>
    </div>
  );
}
